import React from 'react';
import styled from 'styled-components';
import { ReactComponent as CrownPointy } from '../../assets/icons/crown-pointy.svg';

const BubbleContainer = styled.div`
  background-color: var(--color-white);
  border: 1px solid var(--color-gray-100);
  border-radius: 100%;
  padding: 0.7rem;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: var(--shadow-md);
`;

type BubbleProps = {
  children?: React.ReactNode;
};
const Bubble = ({ children }: BubbleProps) => {
  return <BubbleContainer>{children}</BubbleContainer>;
};

const Premium = () => {
  const PremiunStyled = styled(CrownPointy)`
    height: 1.6rem;
    path {
      fill: #ab961f;
    }
  `;
  return (
    <Bubble>
      <PremiunStyled />
    </Bubble>
  );
};

Bubble.Premium = Premium;
export default Bubble;
